import { FC, useState, useRef, ReactNode } from "react";
import Draggable, {
  ControlPosition,
  DraggableData,
  DraggableEvent,
} from "react-draggable";
import { Modal, ModalProps } from "antd";
import { CloseSvg } from "../../../assets/customIcons";
import styles from "./DraggableModal.module.scss";
import BasicModal from "../BasicModal/BasicModal";

interface IDraggableModalProps extends ModalProps {
  defaultPosition?: ControlPosition;
}

export const DraggableModal: FC<IDraggableModalProps> = ({
  children,
  defaultPosition,
  title,
  ...otherProps
}) => {
  const draggableRef = useRef(null);
  const [disabled, setDisabled] = useState(false);

  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });
  var notDrag = false;

  const onFormClick = ()=>{
    notDrag = true;
  }

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggableRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    if (notDrag){
      return;
    }

    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  return (
    <BasicModal
      title={
        <div
          // eslint-disable-next-line
          //@ts-ignore
          className={styles.draggableTitle}
          onMouseOver={() => {
            if (disabled) {
              setDisabled(false);
            }
          }}
          onMouseOut={() => {
            setDisabled(true);
          }}
          onFocus={() => {}}
          onBlur={() => {}} // end
          onMouseDown={()=>notDrag=false}
        >
          {title}
        </div>
      }
      modalRender={(modal) => (
        // eslint-disable-next-line
        //@ts-ignore
        <Draggable
          disabled={disabled}
          defaultPosition={defaultPosition}
          bounds={bounds}
          onStart={(event, uiData) => onStart(event, uiData)}
        >
          <div ref={draggableRef}>{modal}</div>
        </Draggable>
      )}
      closeIcon={<CloseSvg />}
      {...otherProps}
    >
      <div onMouseDown={()=>{onFormClick()}}>{children}</div>
    </BasicModal>
  );
};
